<template>
  <div class="share">
    <a class="icon" :class="{ hover: hoverIndex == 0}" @touchstart="startHover(0)" @mouseover="startHover(0, true)" @mouseout="hoverIndex = -1" target="_blank" :href="`https://www.facebook.com/sharer/sharer.php?u=${link}`"><i class="facebook"></i><i class="facebook"></i>Facebook</a>
    <a class="icon" :class="{ hover: hoverIndex == 1}" @touchstart="startHover(1)" @mouseover="startHover(1, true)" @mouseout="hoverIndex = -1" v-if="isMobile" target="_blank" :href="`fb-messenger://share/?link=${link}`"><i class="messenger"></i><i class="messenger"></i>Messenger</a>
    <a class="icon" :class="{ hover: hoverIndex == 2}" @touchstart="startHover(2)" @mouseover="startHover(2, true)" @mouseout="hoverIndex = -1" target="_blank" :href="`https://twitter.com/home?status=${link}`"><i class="twitter"></i><i class="twitter"></i>Twitter</a>
    <a class="icon" :class="{ hover: hoverIndex == 3}" @touchstart="startHover(3)" @mouseover="startHover(3, true)" @mouseout="hoverIndex = -1" v-if="isMobile" target="_blank" :href="`https://wa.me/?text=${encodeURIComponent(`Musical Freedom Records - ${link}`)}`"><i class="whatsapp"></i><i class="whatsapp"></i>WhatsApp</a>
    <a class="icon" :class="{ hover: hoverIndex == 4}" @touchstart="startHover(4)" @mouseover="startHover(4, true)" @mouseout="hoverIndex = -1" target="_blank" :href="link" v-on:click="copyToClipboard($event)"><i class="anchor"></i><i class="anchor"></i>Link</a>
    <span class="link-clipboard" ref="link-clipboard">Link Copied to Clipboard</span>
  </div>
</template>

<script>
import { copyTextToClipboard } from '@/core/Utils'
import TweenMax from 'gsap'

export default {
  name: 'Share',
  props: ['track'],
  data () {
    return {
      hoverIndex: -1
    }
  },
  computed: {
    link() {
      return (process.env.ROOT_URL.indexOf('http') == -1 ? 'https:' : '') + process.env.ROOT_URL + this.track.slug
    },
    isMobile () {
      return this.$mobileDetect.mobile()
    }
  },
  methods: {
    copyToClipboard(evt) {
      if (evt) evt.preventDefault()
      if (copyTextToClipboard(this.link, this.$mobileDetect.mobile())) {
        TweenMax.killTweensOf(this.$refs['link-clipboard'], { opacity: true })
        TweenMax.to(this.$refs['link-clipboard'], 1, {
          autoAlpha:1,
          repeat:1,
          yoyo:true,
          ease: Linear.easeOut
        })
      }
    },
    startHover (index, isMouse) {
      if (isMouse && this.isMobile) {
        return
      }
      this.hoverIndex = index
      document.body.addEventListener('touchend', this.endHover)
      window.addEventListener('focus', this.endHover)
    },  
    endHover () {
      this.hoverIndex = -1
      document.body.removeEventListener('touchend', this.endHover)
      window.removeEventListener('focus', this.endHover)      
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables';
@import '../scss/easing';
.share {
  @media screen and (max-width: 64em) {
    z-index: 10 !important;
    top: 100px !important;
  }
  background-color: $black;
  padding: 0px;
  border: 1px solid #000;

  .link-clipboard {
    opacity: 0;
    font-size: 12px;
    position: absolute;
    background: $yellow;
    color: $black;
    left: -190px;
    bottom: 15px;
    width: 160px;
    padding: 8px;
    border-radius: 20px;
    text-align: center;
  }

  .icon {
    display: block;
    background-repeat: none;
    background-size: cover;
    text-indent: -99em;
    overflow: hidden;
    filter: invert(100%);
    font-size: 0px;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }

    background: linear-gradient(to left, #000 0%, #000 50%, #fff 51%, #fff 100%);
    background-size: 210% 100%;
    padding: 18px;
    transition: background 0.4s $easeOutQuint;

    @media screen and (max-width: 64em) {
      padding: 10px;
    }
    i {
      width: 25px;
      height: 25px;
      background-repeat: none;
      background-size: cover;    
      display: block;
      position: relative;

      &.facebook { background-image: url('/static/images/facebook.svg') }
      &.twitter { background-image: url('/static/images/twitter.svg') }
      &.messenger { background-image: url('/static/images/messenger.svg') }
      &.anchor { background-image: url('/static/images/anchor.svg') }
      &.whatsapp { background-image: url('/static/images/whatsapp.svg') }

      transition: transform 3s $easeOutBack, opacity 0.3s linear;

      &:last-child {
        filter: invert(100%);
        position: absolute;
        top: 18px;
        left: 18px;
        transform: translate3d(15px, 0px, 0px);
        transition: transform 0.3s $easeOutBack, opacity 0.3s linear;
        opacity: 0;
        @media screen and (max-width: 64em) {
          top: 10px;
          left: 10px;
        }
      }
    }

    &.hover {
      background-position: 100% 0%;
      i:last-child {
        transform: translate3d(0px, 0px, 0px);
        opacity: 1;
      }
      i:first-child {
        transform: translate3d(-50px, 0px, 0x);
        opacity: 0;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Share.vue